import React, { useState , useRef, useEffect} from 'react';
import { Button } from 'primereact/button';


import logoDatacountV2 from './logoDatacountV2.png'
import { useNavigate } from 'react-router-dom';  // Importar useNavigate
import { useLocation } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Ripple } from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';

export default function LayoutNovo(props) {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const {visible, setVisible, showMessage, setLoading} = props;
    const btnRef1 = useRef(null);
    const btnRef2 = useRef(null);
    const btnRef3 = useRef(null);
    const btnRef4 = useRef(null);
    const btnRef5 = useRef(null);
    const navigate = useNavigate();  // Hook para navegação
    const location = useLocation();

    const accept = () => {
       // showMessage('Aguarde... processando', 'info')
        setLoading(true)
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('habilitarcollector');
        sessionStorage.removeItem('habilitarinventory');
        sessionStorage.removeItem('BarenToken');
        sessionStorage.removeItem('empresas');
        sessionStorage.removeItem('dataEmpresa')
        setTimeout(()=>{
            setLoading(false)
            navigate('/');
        }, 1000)
    }
    
    const {
        userName,
        tipoAcesso,
        empresa,
        dataEmpresa,
        dataBase,
        habilitarcollector,
        habilitarinventory,
      } = props || {};


    const handleLogoutClick = () => {
        console.log("Clicou em sair");
        
        confirmDialog({
            message: 'Tem certeza de que deseja sair?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: accept,
            reject: () => console.log('Logout cancelado'),
        });
    };
const toastBottomCenter = useRef(null);


    
    const showDialogError = (msg, title, severity) =>{
        


        toastBottomCenter.current.show({ severity: severity, summary: title, detail: msg, life: 3000 });  
    }
 const disabledItemMenu = tipoAcesso === 'CLIENTE';

    return (
        <div className="layout-container">
            {/* Sidebar */}
            <div className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`} style={{backgroundColor: 'var(--surface-section)', color: 'var(--text-color)',}}>
                {sidebarOpen ? <div className="sidebar-content">
                   <div style={{ width : '100%'}}>
                        <div id="app-sidebar-2" className="surface-section h-screen block flex-shrink-0 lg:static left-0 top-0  select-none" style={{ width: '100%' }}>
                            <div className="flex flex-column h-full">
                                <div className="flex align-items-center justify-content-center px-2 pt-50 flex-shrink-0" style={{paddingTop :'30px'}}>                                   
                                    <img
                                        src={logoDatacountV2}
                                        alt="Logo"
                                        height="50"
                                        className="mr-3"
                                    />                                                                    
                                </div>
                                <div className="overflow-y-auto pt-3">
                                    <ul className="list-none p-3 m-0">
                                        <li>                               
                                            <ul className="list-none p-0 m-0 overflow-hidden">
                                                <li>                                                  
                                                    <button 
                                                        className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                        onClick={()=>{
                                                            navigate('/painel-revenda', { state: { ...location.state, isMobile : props.isMobile } });
                                                        }}
                                                    >
                                                        <i className="pi pi-chart-line mr-2 "></i>
                                                        <span className="text-sm">Dashboard</span>
                                                        <Ripple />
                                                    </button>
                                                </li>
                                                <li>
                                                    <button 
                                                     
                                                        className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                        onClick={()=>{
                                                            if(disabledItemMenu) {
                                                                showDialogError('Você não tem permissão para acessar este recurso!', 'Datacount - Acesso','warn')
                                                                return;
                                                            }
                                                            navigate('/empresas', { state: { ...location.state, isMobile : props.isMobile } });
                                                        }}
                                                    >
                                                        <i className="pi pi-building-columns mr-2 "></i>
                                                        <span className="text-sm">Empresas</span>
                                                        <Ripple />
                                                    </button>
                                                </li>
                                                <li>
                                                    <button 
                                                        className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                        onClick={()=>{
                                                            if(disabledItemMenu) {
                                                                showDialogError('Você não tem permissão para acessar este recurso!', 'Datacount - Acesso','warn')
                                                                return;
                                                            }
                                                            navigate('/usuarios-revenda', { state: { ...location.state, isMobile : props.isMobile } });
                                                        }}
                                                    >
                                                        <i className="pi pi-user-plus mr-2 "></i>
                                                        <span className="text-sm">Usuários</span>
                                                        <Ripple />
                                                    </button>                                                   
                                                </li>
                                               

                                                <li>
                                                    <StyleClass nodeRef={btnRef1} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">                                                       
                                                       
                                                        <button 
                                                            ref={btnRef1}
                                                            className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"                                                            
                                                        >
                                                            <i className="pi pi-user mr-2 "></i>
                                                            <span className="text-sm">Clientes</span>
                                                            <i className="pi pi-chevron-down  ml-auto mr-1 "></i>
                                                            <Ripple />
                                                        </button> 
                                                    </StyleClass>
                                                    <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">                                                        
                                                        <li>                                                        
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    if(disabledItemMenu) {
                                                                       showDialogError('Você não tem permissão para acessar este recurso!', 'Datacount - Acesso','warn')
                                                                        return;
                                                                    }
                                                                    navigate('/clientes', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-user-plus mr-2 "></i>
                                                                <span className="text-sm">Cadastro</span>
                                                                <Ripple />
                                                            </button> 
                                                        </li>
                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    if(disabledItemMenu) {
                                                                       showDialogError('Você não tem permissão para acessar este recurso!', 'Datacount - Acesso','warn')
                                                                        return;
                                                                    }
                                                                    navigate('/importar-clientes', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-download mr-2 "></i>
                                                                <span className="text-sm">Importar</span>
                                                                <Ripple />
                                                            </button> 
                                                        </li>
                                                        
                                                    </ul>
                                                </li>
                                                {/*
                                                <li>
                                                    <StyleClass nodeRef={btnRef2} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">                                                       
                                                       
                                                        <button 
                                                            ref={btnRef2}
                                                            className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"                                                            
                                                        >
                                                            <i className="pi pi-sitemap mr-2 "></i>
                                                            <span className="text-sm">Collector</span>
                                                            <i className="pi pi-chevron-down ml-auto mr-1 "></i>
                                                            <Ripple />
                                                        </button> 
                                                    </StyleClass>
                                                    <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">                                                        
                                                        <li>                                                        
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/clientes', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-key mr-2 "></i>
                                                                <span className="text-sm">Licenças</span>
                                                                <Ripple />
                                                            </button> 
                                                        </li>
                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/clientes', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-share-alt mr-2 "></i>
                                                                <span className="text-sm">DCAs</span>
                                                                <Ripple />
                                                            </button> 
                                                        </li>
                                                        
                                                    </ul>
                                                </li>
                                                    */
                                                    }

                                                <li>
                                                    <StyleClass nodeRef={btnRef3} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                        <button 
                                                            ref={btnRef3}
                                                            className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"                                                            
                                                        >
                                                            <i className="pi pi-print mr-2 "></i>
                                                            <span className="text-sm">Equipamentos</span>
                                                            <i className="pi pi-chevron-down ml-auto mr-1 "></i>
                                                            <Ripple />
                                                        </button> 
                                                    </StyleClass>
                                                    <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">                
                                                        <li>

                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/descobertas-equipamentos', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-search mr-2"></i>
                                                                <span className="text-sm">Descobertas</span>
                                                                <Ripple />
                                                            </button> 
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/parque-equipamentos', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-th-large mr-2"></i>
                                                                <span className="text-sm">Parque</span>
                                                                <Ripple />
                                                            </button> 
                                                        
                                                        </li>

                                                        <li>
                                 
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/parque-desconectados', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-times-circle mr-2"></i>
                                                                <span className="text-sm">Sem Conexão</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/parque-desabilitados', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-times  mr-2"></i>
                                                                <span className="text-sm">Desabilitados</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>

                                                        <li>
                                                          
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/alertas-suprimentos', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-bell mr-2"></i>
                                                                <span className="text-sm">Alertas Toner</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/trocas-toner', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-replay mr-2"></i>
                                                                <span className="text-sm">Trocas Toner</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/previsoes-troca', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-calendar-clock mr-2"></i>
                                                                <span className="text-sm">Previsões Troca</span>
                                                                <Ripple />
                                                            </button> 
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/alertas-pecas', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-history  mr-2"></i>
                                                                <span className="text-sm">Alertas Parts</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/alertas-manutencao', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-wrench  mr-2"></i>
                                                                <span className="text-sm">Service Call</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <button 
                                                                className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                                onClick={()=>{
                                                                    navigate('/alertas-atolamento', { state: { ...location.state, isMobile : props.isMobile } });
                                                                }}
                                                            >
                                                                <i className="pi pi-sort-alt-slash  mr-2"></i>
                                                                <span className="text-sm">Atolamentos</span>
                                                                <Ripple />
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </li>
                                               
                                                <li>
                                                    <button 
                                                        className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                        onClick={()=>{
                                                            navigate('/parque-inventory', { state: { ...location.state, isMobile : props.isMobile } });
                                                        }}
                                                    >
                                                        <i className="pi pi-microchip mr-2 "></i>
                                                        <span className="text-sm">Computadores</span>
                                                        <Ripple className ='ml-5'/>
                                                    </button> 
                                                </li>

                                                  {
                                                    /*
                                                         
                                                <li>
                                                    <button 
                                                        className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                        onClick={()=>{
                                                            navigate('/painel-relatorios-clientes', { state: { ...location.state, isMobile : props.isMobile } });
                                                        }}
                                                    >
                                                        <i className="pi pi-receipt mr-2 "></i>
                                                        <span className="text-sm">Relatorios</span>
                                                        <Ripple />
                                                    </button> 
                                                </li>
*/
                }

                                                <li>
                                                    <StyleClass nodeRef={btnRef5} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                        <button 
                                                            ref={btnRef5}
                                                            className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"                                                            
                                                        >
                                                            <i className="pi pi-cloud-download mr-2 "></i>
                                                            <span className="text-sm">Downloads</span>
                                                            <i className="pi pi-chevron-down ml-auto mr-1 "></i>
                                                            <Ripple />
                                                        </button> 
                                                    </StyleClass>
                                                    <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">               
                                                        <li>
                                                            <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                                                <i className="pi pi-chart-line mr-2"></i>
                                                                <span className="text-sm">Expenses</span>
                                                                <Ripple />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <button 
                                                    className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full bg-transparent border-none"
                                                    onClick={handleLogoutClick}
                                                >
                                                    <i className="pi pi-sign-out mr-2"></i>
                                                    <span className="text-sm">Sair</span>
                                                    <Ripple />
                                                </button>
 
                                            </ul>
                                        </li>
                                    </ul>
                                    
                                </div>
                                <div className="mt-auto">
                                    <hr className="mb-3 mx-3  border-none surface-border" />
                                    <a  className="m-3 flex align-items-center cursor-pointer p-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                    <span className="p-field" style={{fontSize : '10px', color:'#ccc'}}>® 2025 - Printerconnect</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null }
            </div>

            {/* Conteúdo principal */}
            <div className="main-content" >
                
                <div className=''>
                    <Button
                      icon={sidebarOpen ? 'pi pi-angle-left' : 'pi pi-angle-right'}
                      onClick={() => setSidebarOpen(prev => !prev)}
                      className="mb-4"
                      severity='secondary'
                    />
                </div>
                <div>adsasd</div>
            </div>
        </div>
    );
}
